module.exports = __webpack_public_path__ + "img/herby-1(375).11cd43c4.png";